import { action } from 'sky-engine/api/index'

import { CASE_MNG, CASE_REPO } from '@/api/apiModules'

/**
 * 根据版本统计
 * @param {*} data
 * @returns
 */
export function getInstStatistics(data) {
  return action(CASE_MNG, 'inst/statistics', data)
}

/**
 * 根据版本统计
 * @param {*} data
 * @returns
 */
export function getInstList(data) {
  return action(CASE_MNG, 'inst/list', data)
}

/**
 * 是否导出设置
 * @param {*} data
 * @returns
 */
export function setInstExport(data) {
  return action(CASE_MNG, 'inst/setExport', data)
}

/**
 * 生成测试用例
 * @param {*} data
 * @returns
 */
export function createTestCase(data) {
  return action(CASE_MNG, 'inst/create', data)
}

/**
 * 添加测试用例
 * @param {*} data
 * @returns
 */
export function addTestCase(data) {
  return action(CASE_MNG, 'inst/add', data)
}

/**
 * 用例详情
 * @param {*} data
 * @returns
 */
export function getTestCaseDetail(data) {
  return action(CASE_REPO, 'detail', data)
}
